// extracted by mini-css-extract-plugin
module.exports = {"headerAfs":"Public_headerAfs__6R09D","footerAfs":"Public_footerAfs__2hyvh","headerIpc":"Public_headerIpc__3g3d-","footerIpc":"Public_footerIpc__GfGEB"};